module.exports = __webpack_public_path__ + "static/media/sos-logo.f609afea.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/CA/sos-logo.png
// module id = 1503
// module chunks = 0